var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.403 1.352A1.891 1.891 0 0 0 8.18 2.696l-.053.235-2.056.01-2.056.009-.232.114c-.304.15-.569.415-.719.719l-.114.232v11.97l.114.232c.15.304.415.569.719.719l.232.114h11.97l.232-.114c.304-.15.569-.415.719-.719l.114-.232V4.015l-.114-.232a1.623 1.623 0 0 0-.719-.719l-.232-.114-2.056-.009-2.057-.01-.023-.14a1.911 1.911 0 0 0-.821-1.239c-.427-.288-1.115-.373-1.625-.2m.798 1.048c.22.061.433.361.432.607-.003.314-.317.626-.633.626a.773.773 0 0 1-.404-.158.613.613 0 0 1-.166-.725c.145-.313.434-.444.771-.35m5.551 1.848.081.082v11.34l-.081.082-.082.081H4.33l-.082-.081-.081-.082V4.33l.081-.082.082-.081h11.34l.082.081M6.048 6.176a6.578 6.578 0 0 0-.007.625l.009.582h7.9V6.15l-3.943-.008c-3.193-.007-3.945-.001-3.959.034m0 3.233a6.593 6.593 0 0 0-.007.626l.009.582h7.9V9.383l-3.943-.008c-3.193-.007-3.945 0-3.959.034m0 3.234a6.567 6.567 0 0 0-.007.625l.009.582h5.4v-1.233l-2.693-.009c-2.175-.007-2.695 0-2.709.035",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentType);
export default __webpack_public_path__ + "static/media/equipment-type.99a79fc4af964b1d0167bc12fde1248f.svg";
export { ForwardRef as ReactComponent };